module.exports = __webpack_public_path__ + "static/img/ic_no_trainings.e2ba8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ic_no_trainings.png
// module id = 37
// module chunks = 0